import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MarqueeRibbon } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { StickerCalculator } from "@/components/StickerCalculator";
import { BannerCalculator } from "@/components/BannerCalculator";
import { Process } from "@/components/Process";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import BrandPage from "@/pages/BrandPage";
import QuestionnairePage from "@/pages/QuestionnairePage";

const Home = () => {
  return (
    <div className="min-h-screen bg-navy text-white font-body">
      <Navbar />
      <main>
        <Hero />
        <MarqueeRibbon />
        <Services />
        <StickerCalculator />
        <BannerCalculator />
        <Process />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/brand" element={<BrandPage />} />
          <Route path="/questionnaire" element={<QuestionnairePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0C0C0E",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#ffffff",
          },
        }}
      />
    </div>
  );
}

export default App;
